import { DataItem } from 'scrivito'

import { getImageBinary } from './getImageBinary'

export const getImageSrcFromDataItem = (dataItem: DataItem) => {
  const dataClassName = dataItem.dataClassName() || ''
  const imageBinary = getImageBinary(dataClassName, dataItem)

  return imageBinary
}
